/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum RodzajRelacjiTyp {
  MaFormat = 'MA_FORMAT',
  JestFormatem = 'JEST_FORMATEM',
  MaWersje = 'MA_WERSJE',
  JestWersja = 'JEST_WERSJA',
  MaCzesc = 'MA_CZESC',
  JestCzescia = 'JEST_CZESCIA',
  MaOdniesienie = 'MA_ODNIESIENIE',
  OdnosiSieDo = 'ODNOSI_SIE_DO',
  MaZrodlo = 'MA_ZRODLO',
  Wymaga = 'WYMAGA',
  JestWymagany = 'JEST_WYMAGANY',
  MaDekretacje = 'MA_DEKRETACJE',
  JestDekretacja = 'JEST_DEKRETACJA',
  Inna = 'INNA'
}
